import { apiClient } from '../api/apiClient';

export const subscriptionService = {
    getStatus() {
        return apiClient.get('subscription/status');
    },

    createCheckoutSession(payload) {
        return apiClient.post('subscription/create-checkout-session', { json: payload });
    },

    validatePromoCode(promoCode) {
        return apiClient.post('subscription/validate-promo', { json: { promoCode } });
    },

    createPortalSession() {
        return apiClient.post('subscription/portal');
    },

    getCheckoutSession(sessionId) {
        return apiClient.get(`subscription/checkout-session/${sessionId}`);
    }
};
